// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message_message__28eE6 {
  position: fixed;
  bottom: 0;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: var(
    --Yalda-Btn,
    linear-gradient(217deg, #c80b14 33.4%, #df4051 92.35%)
  );
  box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),
    0px 60px 24px 0px rgba(0, 0, 0, 0.01), 0px 34px 20px 0px rgba(0, 0, 0, 0.05),
    0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 9999;
  gap: 8px;
}
.message_message__28eE6 img {
  width: 26px;
}
.message_show__AwwJm {
  animation: message_client-ip__JSqgl 2s forwards;
}
@keyframes message_client-ip__JSqgl {
  0% {
    bottom: -41px;
  }
  50% {
    bottom: 10px;
  }
  100% {
    bottom: 0px;
  }
}
.message_close__OJMw\\+ {
  animation: message_close-ip-message__W15KW 5s forwards;
}
@keyframes message_close-ip-message__W15KW {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.message_message__28eE6 span {
  font-family: dana, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/message/message.module.css"],"names":[],"mappings":"AAAA;EAKE,eAAe;EACf,SAAS;EACT,2CAA2C;EAC3C;;;GAGC;EACD;;6EAE2E;EAC3E,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;EACE,+CAAgC;AAClC;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,sDAAuC;AACzC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".message {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  bottom: 0;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: var(\n    --Yalda-Btn,\n    linear-gradient(217deg, #c80b14 33.4%, #df4051 92.35%)\n  );\n  box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),\n    0px 60px 24px 0px rgba(0, 0, 0, 0.01), 0px 34px 20px 0px rgba(0, 0, 0, 0.05),\n    0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);\n  height: 37px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  z-index: 9999;\n  gap: 8px;\n}\n.message img {\n  width: 26px;\n}\n.show {\n  animation: client-ip 2s forwards;\n}\n@keyframes client-ip {\n  0% {\n    bottom: -41px;\n  }\n  50% {\n    bottom: 10px;\n  }\n  100% {\n    bottom: 0px;\n  }\n}\n.close {\n  animation: close-ip-message 5s forwards;\n}\n@keyframes close-ip-message {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.message span {\n  font-family: dana, sans-serif;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `message_message__28eE6`,
	"show": `message_show__AwwJm`,
	"client-ip": `message_client-ip__JSqgl`,
	"close": `message_close__OJMw+`,
	"close-ip-message": `message_close-ip-message__W15KW`
};
export default ___CSS_LOADER_EXPORT___;
